import { useMemo } from "react";
import { connect } from "react-redux";
import slugify from "slugify";
import { Center, CardsGrid } from "./styles";
import CardAticle from "../../../components/CardArticle";
import PostCardSkeleton from "../../../components/PostCardSkeleton";
import { Group } from "../../../../../../types/group";
import { Post } from "../../../../../../types/post";
import { Line } from "../../../../components/Statistics/styles";
import { SectionTitle, SectionDescription } from "../../styles";
import EmptyCard from "../../../../components/EmptyCard";
import postPinCheckedIcon from "../../../../../../assets/icons/post-pin-checked-icon.svg";
import Grid from "../../../../../../components/Grid";
import Carousel from "../../../../../../components/Carousel";
import ReorderButton from '../ReorderButton'
import { useWindowSize } from "../../../../../../hooks/useWindowSize";

const groupTypes = {
  membership: "membresía",
  experience: "taller",
  free_experience: "evento",
};

interface ComponentProps {
  group: Group;
  groupStates: {
    loading: boolean;
    success: boolean;
    error: string | boolean;
  };
  featuredPosts: Post[];
  featuredPostsStates: {
    loading: boolean;
    success: boolean;
    error: string | boolean;
  };
  setShowReorderPinedPostsSidebarVisble;
  setIdArticleToDelete;
  setUnpinedItem;
}

const Component = ({
  group,
  featuredPosts,
  featuredPostsStates,
  setShowReorderPinedPostsSidebarVisble,
  setIdArticleToDelete,
  setUnpinedItem
}: ComponentProps) => {
  const { isMobile } = useWindowSize()
  const shouldShowEmptyState = useMemo(() => {
    if (featuredPostsStates.loading) return false;

    const noPosts = !featuredPosts || featuredPosts?.length <= 0;
    const hasError = !!featuredPostsStates.error;

    return noPosts || hasError;
  }, [featuredPosts, featuredPostsStates]);

  return group?.group_type !== "free_experience" ? (
    <>
      <Grid.Container>
        <Grid.Row>
          <Grid.Col>
            <Center horizontal={isMobile ? 'left' : 'space'} vertical={isMobile ? 'top' : 'center'} column={isMobile} gap={isMobile ? 14 : 0}>
              <SectionTitle>Artículos pineados</SectionTitle>
              {!isMobile && <ReorderButton onClick={() => setShowReorderPinedPostsSidebarVisble(true)} />}
            </Center>

            <div style={{ height: isMobile ? 16 : 24 }} />

            <SectionDescription>Estos articulos se mostraran en la pagina de inicio de tu membresia </SectionDescription>

            {isMobile && (
              <>
                <div style={{ height: 16 }} />
                <ReorderButton onClick={() => setShowReorderPinedPostsSidebarVisble(true)} />
              </>
            )}
          </Grid.Col>
        </Grid.Row>
      </Grid.Container>

      <div style={{ height: isMobile ? 16 : 32 }} />

      {!featuredPosts && featuredPostsStates.loading && (
        <CardsGrid>
          <PostCardSkeleton />
          <PostCardSkeleton />
          <PostCardSkeleton />
        </CardsGrid>
      )}

      {shouldShowEmptyState ? (
        <EmptyCard
          title="No tienes artículos destacados"
          text={`Destaca aquellos artíulos que consideres mayor relevancia para los suscriptores de tu ${groupTypes[group?.group_type]
            }.`}
          icon={postPinCheckedIcon}
        />
      ) : (
        <Grid.Container>
          <Grid.Row>
            <Grid.Col>
              <Carousel
                items={featuredPosts}
                renderItem={(post: Post, index: number) => (
                  <CardAticle
                    key={slugify(post.title + index, {
                      lower: true,
                    })}
                    post={post}
                    onDelete={(idPost) =>
                      setIdArticleToDelete(idPost)
                    }
                    groupInformation={group}
                    onUnpinIt={setUnpinedItem}
                  //blockedPost={!post?.user_access_data?.is_unlocked}
                  />
                )}
                slidesToShow={4}
                scrollAmount={250}
                animationSpeed={400}
                showArrows={featuredPosts?.length >= 4}
                cardWidth="295px"
              />
            </Grid.Col>
          </Grid.Row>
        </Grid.Container>
      )}

      {!isMobile && (
        <>
          <div style={{ height: 18 }} />

          <Grid.Container>
            <Grid.Row>
              <Grid.Col>
                <Line />
              </Grid.Col>
            </Grid.Row>
          </Grid.Container>
        </>
      )}

      <div style={{ height: isMobile ? 46 : 42 }} />
    </>
  ) : (
    <></>
  );
};

const state = ({ groupStore, postStore }) => {
  const { data: group, states: groupStates } = groupStore.group;
  const { data: featuredPosts, states: featuredPostsStates } = postStore.featuredPosts;

  return {
    group,
    groupStates,
    featuredPosts,
    featuredPostsStates
  };
};

export default connect(state)(Component);
